import { StudentDebtStoreService } from '@hb/modules/financial-obligations/student-debt/student-debt-store.service';
import { StudentDebtQuestion } from '@hb/domain/steps/financial-obligation';
import { PreviousButtonComponent } from '@hb/modules';
import { StudentDebtAmountComponent } from '@hb/modules/financial-obligations/student-debt/student-debt-amount/student-debt-amount.component';

import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'student-debt',
    templateUrl: './student-debt.component.html',
    imports: [PreviousButtonComponent, StudentDebtAmountComponent, ApContentPipe],
    styleUrls: ['../../global/global.scss']
})
export class StudentDebtComponent implements OnInit, OnDestroy {
    protected readonly store = inject(StudentDebtStoreService);
    protected activeQuestion: StudentDebtQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy() {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showStudentDebtMonthlyAmount(): boolean {
        return (
            this.activeQuestion === StudentDebtQuestion.MONTHLY_AMOUNT ||
            (this.store.isActiveQuestion(StudentDebtQuestion.MONTHLY_AMOUNT) && this.store.isSummary)
        );
    }
}
